
import i18n from '../../../../i18n/i18n'
export var validationMessage=[];

const EntrykeysValidationMessage={
    Quantity_Required:'Quantity_Required',
    Price_Required:'Price_Required',
    Material_Required:'Material_Required',
}


/**
 * dictionary contain message
 * ar is Arabic language, en is English langauge 
 */
const EntryValidationMessage = {
    Quantity_Required: { ar:"يجب إدخال إحدى حقل الكمية", en:"Quantity is required", es: 'Se requiere cantidad' },
    Price_Required: { ar:"يجب إدخال إحدى حقل السعر", en:"Price is required", es: 'Se requiere precio' },
    Material_Required: { ar:"يجب إدخال إحدى حقل المادة", en:"Item is required ", es: 'Se requiere artículo' },
};


function pushMessage(key){
    let message= EntryValidationMessage[key][i18n.locale];
    if(!validationMessage.includes(message)){
        validationMessage.push(message);
    }
}

function intiLinkedRules(linkedRules){
    Object.keys(linkedRules).forEach(value => linkedRules[value] = true)
}

/**
 * Detected change entry row of smart table (Materials Mode) and enabled valid scenarios.
 *
 * @param {Object} entry entry object .
 * @param {Object} linkedRules dictionary of rules.
 * @return {Array} array of validationMessages.
 */
export function invoiceEntryDetectedValidation(entry, linkedRules, skipValidation = {}){

    validationMessage=[];  //clear old =0
    intiLinkedRules(linkedRules);

    // Material
    if(!entry.material_id){
        pushMessage(EntrykeysValidationMessage.Material_Required);
        linkedRules.material_id = false;
    }
    // Price
    if(!entry.price && !skipValidation.price){
        pushMessage(EntrykeysValidationMessage.Price_Required);
        linkedRules.price = false;
    }
    // MaterialAmount
    if(!entry.quantity){
        pushMessage(EntrykeysValidationMessage.Quantity_Required);
        linkedRules.quantity = false;
    }
    return validationMessage;
}